import { combineReducers } from '@reduxjs/toolkit';
import { searchReducer } from 'components/Body/Search/store'
import { dataEntryReducer } from 'components/Body/data-entry/store' 


export const bodyReducers = combineReducers({
    search: searchReducer,
    dataEntry: dataEntryReducer
})
